import moment from 'moment';
import { TypeStaffTask } from '../enumerates/type-staff-task';
import { ScheduleInfoBasicDto } from '../models/calendar/schedule/schedule-info-basic';
import { ScheduleDataState } from '../models/calendar/schedule/schedule-state';
import { Task } from '../models/task/task';
import { Activity } from '../models/activity/activity';
import { EnumData } from '../models/generic/enumdata';

export function isScheduleInfoBasicDto(item: ScheduleInfoBasicDto | Task): item is ScheduleInfoBasicDto {
    return (item as ScheduleInfoBasicDto).bookingState !== undefined;
}

type IsActivityItemType = ScheduleInfoBasicDto | Task | Activity;

export function isActivity(item: IsActivityItemType): boolean {
    if (!(item as Task)?.idTask) {
        return true;
    }

    return false;
}

export function isTask(item: IsActivityItemType): boolean {
    return (item as Task)?.typeStaffTask === TypeStaffTask.tarea;
}

export function taskIsService(item: ScheduleInfoBasicDto | Task): boolean {
    return (item as Task)?.typeStaffTask === TypeStaffTask.servicio;
}

export function isScheduleItem(item: IsActivityItemType): boolean {
    return (item as Task).idRol !== undefined;
}

export function generateTask(item: Task | ScheduleInfoBasicDto | Activity): Task {
    if (!isActivity(item)) {
        const taskItem: Task = item as Task;

        return taskItem;
    } else {
        const scheduleItem: ScheduleInfoBasicDto = item as ScheduleInfoBasicDto;

        const newItem = {
            dateSchedule: new Date(`${moment().format('YYYY-MM-DD')}T${scheduleItem.timeStart}:00`),
            duration: scheduleItem.duration,
            name: scheduleItem.activity.name,
            room: scheduleItem.room.room,
            memberName: '',
            memberLastName: '',
            color: '#' + scheduleItem.activity.colorScheduler,
            id: scheduleItem.id,
            idTask: 0,
            idRol: 0,
            idMember: 0,
            typeStaffTask: 1,
            dateValidation: undefined,
            type: 0,
            code: '',
            dateShow: undefined,
            hourShow: scheduleItem.hourShow,
            bookingInfo: scheduleItem.bookingInfo,
            capacityAssistant: scheduleItem.capacityAssistant,
            targetAssistant: scheduleItem.targetAssistant,
            description: scheduleItem.observation,
            idHash: scheduleItem.idHash
        };

        return newItem;
    }
}

export function getTaskStatus(item: any): ScheduleDataState {
    if (isScheduleItem(item)) {
        return item.dateValidation ? ScheduleDataState.validated : ScheduleDataState.pending;
    } else {
        return item.currentState;
    }
}

export function getIconStatus(item: Task | ScheduleInfoBasicDto | Activity): string {
    const status: ScheduleDataState = getTaskStatus(item);

    return status === ScheduleDataState.validated ? 'assets/icons/check-circle-fill.svg' : (status === ScheduleDataState.canceled ? 'assets/icons/close-circle.svg' : '');
}

export function enumToArray(enumerable: any): EnumData[] {
    return Object.keys(enumerable).filter(value => isNaN(Number(value)) === false).map(key => ({ id: key, value: enumerable[key] }) as EnumData);
}
